import jade from 'javascripts/core_post_webpack/profile_helpers/file_upload.jst.jade';
window.JST = window.JST || {};
window.JST['core_post_webpack/profile_helpers/file_upload'] = jade;
